import CustomButton from "./components/CustomButton";
import React, { useState, useEffect } from 'react';
import styled from 'styled-components';

const CookieContainer = styled.div<{ visible: boolean }>`
  position: fixed;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  top: 62%; 
  left: 0;
  right: 0;
  margin: 0 auto;
  max-width: 100%;
  width: calc(100% - 40px);
  background-color: #fff;
  color: #333;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.1);
  padding: 16px;
  font-size: 0.8rem;
  font-weight: 400;
  z-index: 1000;
  opacity: ${({ visible }) => (visible ? 1 : 0)};
  pointer-events: ${({ visible }) => (visible ? 'auto' : 'none')};
  transform: translateY(${({ visible }) => (visible ? '0' : '20px')});
  transition: opacity 0.3s ease, transform 0.3s ease;

  @media (min-width: ${({ theme }) => theme.breakpoints.mobile}) {
    padding: 16px 20px;
    font-size: 0.85rem;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.mobileXs}) {
    width: 90%;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.mobileSm}) {
    flex-direction: row;
    justify-content: space-between;
    top: 75%;
    transform: translateX(0) translateY(${({ visible }) => (visible ? '0' : '20px')});
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    width: auto;
    max-width: 80%;
    left: 50%;
    right: auto;
    transform: translateX(-50%) translateY(${({ visible }) => (visible ? '0' : '20px')});
    padding: 16px 24px;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
    max-width: 900px;
  }
`;

const CookieText = styled.p`
  margin: 0;
  text-align: center;

  @media (min-width: ${({ theme }) => theme.breakpoints.mobileSm}) {
    text-align: left;
    max-width: 80%;
  }
`;

const ButtonWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;

  @media (min-width: ${({ theme }) => theme.breakpoints.mobileSm}) {
    width: auto;
    min-width: 120px;
  }
`;

// Consent is already granted before GTM loads, so accepting the notice does not change measurement.
const CookieConsent = () => {
  const [visible, setVisible] = useState(false);
  
  useEffect(() => {
    const consent = localStorage.getItem('cookieConsent');
    if (consent) return;

    const handleScroll = () => {
      
      const scrollPosition = window.scrollY || document.documentElement.scrollTop;
      const pageHeight = document.documentElement.scrollHeight - document.documentElement.clientHeight;
      const scrollTrigger = pageHeight * 0.6;

      if (scrollPosition >= scrollTrigger) {
        setVisible(true);
        
        window.removeEventListener('scroll', handleScroll);
      }
    };

    
    const timer = setTimeout(() => {
      window.addEventListener('scroll', handleScroll);
    }, 1000);

    return () => {
      clearTimeout(timer);
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);
  
  const handleAccept = () => {
    localStorage.setItem('cookieConsent', 'true');
    setVisible(false);
  };
  
  return (
    <CookieContainer visible={visible}>
      <CookieText>
        Este site utiliza cookies para melhorar sua experiência. Ao continuar, você concorda com o uso.
      </CookieText>
      <ButtonWrapper>
        <CustomButton 
          onClick={handleAccept} 
          style={{
            width: '100%',
            padding: '8px 16px',
            whiteSpace: 'nowrap'
          }}
        >
          Aceitar
        </CustomButton>
      </ButtonWrapper>
    </CookieContainer>
  );
};

export default CookieConsent;